<template>
  <div>
    <el-select v-model="selectValue">
      <el-option
          v-for="item in selectData"
          :key="item.value"
          :label="item.label"
          :value="item.value">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import { 
  businessNatureData,
  businessNatureABData,
} from '../../common-data/config.js';

export default {
  name: "BusinessNatrue",

  props: {
    value: {
      type: String,
      default: ""
    },
    agencyBanking: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    // console.log(this.agencyBanking);
    // console.log(businessNatureABData);

    return {
      selectValue: "",
      selectData: this.agencyBanking ? businessNatureABData : businessNatureData,
    }
  },

  watch: {
    value(newValue) {
      this.selectValue = newValue;
    },

    selectValue(newValue) {
      this.$emit("input", newValue);
    }
  }
}
</script>

<style lang="scss" scoped>

</style>